var map = {
	"./back.svg": 7911,
	"./close.svg": 420,
	"./gira.svg": 103,
	"./home.svg": 2520,
	"./identikit.svg": 9808,
	"./inspection-circle.svg": 8494,
	"./inspection.svg": 4772,
	"./inspectionold.svg": 7078,
	"./lupaold.svg": 6833,
	"./map.svg": 5477,
	"./mrt.svg": 3843,
	"./pintag.svg": 2259,
	"./play.svg": 5590,
	"./slider1.svg": 6426,
	"./slider2.svg": 8261,
	"./start.svg": 3816,
	"./touch.svg": 9819,
	"./zoomin.svg": 6861,
	"./zoomout.svg": 6985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;